"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StarOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var StarOutlineSVG = function StarOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16 4.69L19.24 11l.45.88 1 .19 7 1.29-5 5.39-.64.68.12.93 1 7.28-6.2-3.14-.97-.45-.92.47-6.2 3.14 1-7.28.12-.93-.64-.68-5-5.39 7-1.29 1-.19.45-.88L16 4.69M16 2c-.55 0-1.09.41-1.51 1.22L11 10.12l-7.28 1.34c-1.8.34-2.26 1.71-1 3.06l5.16 5.6-1 7.78c-.17 1.32.39 2.1 1.34 2.1a2.68 2.68 0 001.19-.33L16 26.3l6.65 3.37a2.68 2.68 0 001.19.33c.95 0 1.51-.78 1.34-2.1l-1-7.78 5.16-5.6c1.24-1.35.78-2.72-1-3.06L21 10.12l-3.52-6.9C17.09 2.41 16.55 2 16 2z"
  }));
};
exports.StarOutlineSVG = StarOutlineSVG;
StarOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(StarOutlineSVG);
exports.default = _default;